import React from 'react';

import routes from './config/route';

import { ProvideRouter }  from './hooks/router/Router';
import Route from './hooks/router/Route';

import ErrorPage from './pages/errorPage/ErrorPage';
import GuestLayout from './layouts/GuestLayout';

export default function App ({ route }) {
  return (
    <ProvideRouter routes={routes} defaultRoute={route}>
      <GuestLayout>
        <Route notFound={ErrorPage} />
      </GuestLayout>
    </ProvideRouter>
  );
};
